import { environment } from './constant'

const globalEnv = {
  ...environment,
  specialQuoteFlag: `$${new Date().getTime()}$`
}
export default globalEnv
